export const HTTP_STATUS_ERROR_CODES = {
  BAD_REQUEST: 400,
};
